import Styled, { css } from 'styled-components';

import { media } from '../../../../lib/StyledComponents/StyledComponents';
import { SVGIconStyleWrapper } from '../../../Icon/SVGIcon';
import { cssDeclaration } from '../../Utils';

const commonDropdownStyles = css`
  height: 100%;
  display: flex;
  align-items: center;
`;

export const HeaderDropdownListItem = Styled.li`
  list-style: none;
  ${commonDropdownStyles}
`;

export const HeaderDropdownWrapper = Styled.div`
  ${commonDropdownStyles}
`;

export const HeaderDropdownButton = Styled.button<{ isOpen: boolean }>`
  display: inline-flex;
  transition: color 100ms ease-out;

  ${SVGIconStyleWrapper} {
    display: inherit;
    transition: color 100ms ease-out;
  }

  ${({ theme: { themeTwo }}) => {
    const { layout: { header: { dropdown: { button }}}} = themeTwo;
    const { state: { hover }} = button;
    const isAmount = themeTwo.name === 'amount' || themeTwo.name === 'amountDark';

    return css`
      line-height: ${button.font.lineHeight};
      font-weight: ${button.font.weight};
      /* color */ ${cssDeclaration(themeTwo, 'color', button.font.color)};
      /* font-size */ ${cssDeclaration(themeTwo, 'font-size', button.font.size)};
      /* padding */ ${cssDeclaration(themeTwo, 'padding', button.padding)};
      /* margin */ ${cssDeclaration(themeTwo, 'margin', button.margin)};
      /* background-color */ ${cssDeclaration(themeTwo, 'background-color', button.backgroundColor)};

      // can be removed once amount updates thier font from sailec
      ${isAmount && css`
        margin-top: 4px;
      `}

      &:hover {
        font-weight: ${hover.font && hover.font.weight};
        /* font-size */ ${hover.font && hover.font.size && cssDeclaration(themeTwo, 'font-size', hover.font.size)};
        /* padding */ ${hover.padding && cssDeclaration(themeTwo, 'padding', hover.padding)};
        /* margin */ ${hover.margin && cssDeclaration(themeTwo, 'margin', hover.margin)};
        /* color */ ${hover.font && hover.font.color && cssDeclaration(themeTwo, 'color', hover.font.color)};
        /* background-color */ ${hover.backgroundColor && cssDeclaration(themeTwo, 'background-color', hover.backgroundColor)};


        ${SVGIconStyleWrapper} {
          /* color */ ${hover.font && hover.font.color && cssDeclaration(themeTwo, 'color', hover.font.color)};
        }
      }

      &:focus {
        /* outline */ ${cssDeclaration(themeTwo, 'outline', themeTwo.global.outline)};
      }
    `;
  }}

  & > div > span {
    margin-right: 0.4rem;
  }
`;
